import Model, { attr, belongsTo } from "@ember-data/model";

export default class ServerTemplateModel extends Model {
  @attr basecost;
  @attr bootstrapMethod;
  @attr licensecost;
  @attr minimumDiskSize;
  @attr minimumMemorySize;
  @attr platform;
  @attr supportsCloudInitSshKeys;
  @attr templateId;
  @attr value;

  @belongsTo("project", { async: false, inverse: "serverTemplates" }) project;
}
